import { useState, useRef, useEffect, useMemo } from "react";
import CefxLib from "../../helpers/CefxLib";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";

import { NewSidebarCefx } from "./NewSideberCefx";
import { CefxComponent } from "./CefXComponent";
import { ViewImageComponent } from "./ViewImageComponent";
import {
  selectResearchPatient,
  setResearchPatient,
} from "../../store/slices/researchPatientSlice";
import { OpcoesProvider } from "./NewSideberCefx/OpcoesContext";

import CViewer3d from "./Viewer3d/CViewer3d";
import { selectIsCefalometria } from "../../store/slices/isCefalometriaSlice";
import { selectUser } from "../../store/slices/userSlice";
import { NewSidebarView } from "./NewSidebarView";
import { selectPatientsWithImages } from "../../store/slices/patientsWithImagesSlice";
import Api from "../../helpers/Api";
import { ModalIa } from "./Modals/ModalIa/ModalIa";
import { ModalLoadingProcessIa } from "./Modals/ModalIa/ModalLoadingProcessIa/ModalLoadingProcessIa";
import { isJpnAndPngUtils } from "../../utils/fileTypes/isJpgAndPngUtils";
import { is3dTypeUtils } from "../../utils/fileTypes/is3dTypeUtils";
import { isDicomTypeUtils } from "../../utils/fileTypes/isDicomTypeUtils";
import { isPdfTypeUtils } from "../../utils/fileTypes/isPdfTypeUtils";
import { isRarTypeUtils } from "../../utils/fileTypes/isRarTypeUtils";
import { isVideoTypeUtils } from "../../utils/fileTypes/isVideoTypeUtils";

import styles from "./styles.module.css";

export function ViewImages() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryString = location.search.substring(1);
  const queryParams = new URLSearchParams(queryString);

  const API_URL = process.env.REACT_APP_API_URL;

  const imageParams = queryParams.get("image") || "";
  const idParams = queryParams.get("id") || queryParams.get("idClient");
  const seqAtendParams = queryParams.get("atd");
  const idPacienteParams = queryParams.get("idPacient");
  const ssParams = queryParams.get("ss");
  const tamanhoParams = queryParams.get("tamanho");

  const [showModalIa, setShowModalIa] = useState(false);
  const [imageRotation, setImageRotation] = useState(0);
  const [image3d, setImage3d] = useState(false);
  const [modoCefXViewImage, setModoCefXViewImage] = useState(false);
  const [selectedImage, setSelectImage] = useState([]);
  const [theSelectImage, setTheSelectImage] = useState("");
  const [analysisSelected, setAnalysisSelected] = useState([]);
  const [textPont, setTextPonto] = useState("");
  const [getCollapse, setGetCollapse] = useState(false);
  const [pointNameOnTableClick, setPointNameOnTableClick] = useState({});
  const [pacientSearchCefx, setPacientSearchCefx] = useState(null);
  const [loadingPacientSearchCefx, setLoadingPacientSearchCefx] =
    useState(false);

  const [isModalIaOpen, setIsModalIaOpen] = useState(false);
  const [isModalLoadingOpen, setIsModalLoadingOpen] = useState(false);

  const { isCefalometria } = useSelector(selectIsCefalometria);
  const { researchPatient } = useSelector(selectResearchPatient);
  const { patientsWithImages } = useSelector(selectPatientsWithImages);
  const { user } = useSelector(selectUser);

  const [resultSearch, setResultSearch] = useState(null);

  const getPacient = () => {
    let pacientIsCefalometria;

    if (resultSearch && !isCefalometria) {
      return patientsWithImages.find(
        (p) =>
          p.seqAtend == seqAtendParams &&
          p.idPaciente == idPacienteParams &&
          (p.idClient == idParams || p.idClient == "" || idParams == "")
      );
    }

    if (!resultSearch && !isCefalometria) {
      return patientsWithImages.find(
        (p) =>
          p.seqAtend == seqAtendParams &&
          p.idPaciente == idPacienteParams &&
          (p.idClient == idParams || p.idClient == "" || idParams == "")
      );
    } else if (!resultSearch && isCefalometria && !pacientIsCefalometria) {
      pacientIsCefalometria = patientsWithImages.find(
        (p) =>
          (p.idClient == idParams || p.idClient == "" || idParams == "") &&
          p.seqAtend == seqAtendParams &&
          p.idPaciente == idPacienteParams
      );

      if (resultSearch && !pacientIsCefalometria && isCefalometria) {
        pacientIsCefalometria = patientsWithImages.find(
          (p) =>
            (p.idClient == idParams || p.idClient == "" || idParams == "") &&
            p.seqAtend == seqAtendParams &&
            p.idPaciente == idPacienteParams
        );
      }
      return pacientIsCefalometria;
    }
    return undefined;
  };

  let getPacienteCondicionado = () => {
    // No modo cefalometria, priorizar os dados frescos da busca
    // Verificar se pacientSearchCefx é um objeto válido (não null, não array)
    // ALTERAÇÃO: Removido isCefalometria check para permitir fallback via SS em visualização normal
    if (pacientSearchCefx && typeof pacientSearchCefx === 'object' && pacientSearchCefx.seqAtend) {
      // Validar que pacientSearchCefx corresponde aos parâmetros da URL
      if (
        pacientSearchCefx.seqAtend == seqAtendParams &&
        (pacientSearchCefx.idPaciente == idPacienteParams || !idPacienteParams) &&
        (pacientSearchCefx.idClient == idParams || !pacientSearchCefx.idClient || !idParams)
      ) {
        return pacientSearchCefx;
      }
    }
    
    // Validar que resultSearch corresponde EXATAMENTE aos parâmetros da URL
    if (
      resultSearch &&
      resultSearch.seqAtend == seqAtendParams &&
      resultSearch.idPaciente == idPacienteParams &&
      (resultSearch.idClient == idParams || !resultSearch.idClient || !idParams)
    ) {
      return resultSearch;
    }
    
    // Fallback: buscar na lista de pacientes com imagens
    return getPacient();
  };

  let paciente = getPacienteCondicionado();

  const gettingAllPngOrJpgOrVideoImagens = paciente?.imagensPaciente?.filter(
    (imagem) =>
      imagem.link &&
      (isJpnAndPngUtils(imagem.link) || isVideoTypeUtils(imagem.link)) &&
      !imagem.link.includes("tomo_1")
  ) || [];

  const gettingAllImagens3d = paciente?.imagensPaciente?.filter(
    (imagem) => imagem.link && is3dTypeUtils(imagem.link)
  ) || [];

  const pacienteAllImagensArray = useMemo(() => {
    return gettingAllPngOrJpgOrVideoImagens;
  }, [gettingAllPngOrJpgOrVideoImagens]);

  const pacientAllImagens3d = useMemo(() => {
    return gettingAllImagens3d;
  }, [gettingAllImagens3d]);

  const handleSelectedImage = (image) => {};

  const handleModoCefXViewImage = (cefX) => setModoCefXViewImage(cefX);

  const getImagenRotation = (rotate) => setImageRotation(rotate);

  const handleChanceTheSelectedImage = (urlImage) => {
    setTheSelectImage(urlImage);
    const params = new URLSearchParams(location.search);
    params.set("image", urlImage);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const handleGetNameEndCodAnalyze = (analysisSelected) =>
    setAnalysisSelected(analysisSelected);

  const getTextPont = (textPonto) => setTextPonto(textPonto);

  const handleGetCollapse = (collapse) => setGetCollapse(collapse);

  const handlePontName = (pont) => setPointNameOnTableClick(pont);

  const closeModalIa = () => {
    setIsModalIaOpen(false);
  };

  const openModalIa = () => setIsModalIaOpen(true);

  const openModalLoading = () => setIsModalLoadingOpen(true);

  const closeModalLoading = () => setIsModalLoadingOpen(false);

  const handleLoadIa = () => {
    openModalLoading();
    ocefx.CarregarPontosIa(() => {
      closeModalLoading();
    });
    closeModalIa();
  };

  useEffect(() => {
    if (showModalIa) {
      openModalIa();
    } else {
      closeModalIa();
    }
  }, [showModalIa]);

  useEffect(() => {
    ocefx.setMostrarModalIaCallback((value) => {
      setShowModalIa(value);
    });
  }, []);

  useEffect(() => {
    if (
      (imageParams && is3dTypeUtils(imageParams)) ||
      is3dTypeUtils(imageParams) ||
      isDicomTypeUtils(imageParams)
    ) {
      setImage3d(true);
    }
  }, [imageParams]);

  useEffect(() => {
    // === NOVA LÓGICA: Busca via SS (Session/Security Token) ===
    // Utilizado quando acessado diretamente e o Redux está vazio
    if (ssParams && idParams && seqAtendParams) {
      const fetchViaSS = async () => {
        // Se já tivermos o paciente carregado no state local, evitamos re-fetching desnecessário
        // A menos que seja diferente do URL
        if (pacientSearchCefx && 
            pacientSearchCefx.seqAtend == seqAtendParams && 
            pacientSearchCefx.idPaciente == idPacienteParams) {
          return;
        }

        setLoadingPacientSearchCefx(true);
        console.log("🟠 Iniciando busca via SS Param...");

        try {
          let qrCodeResult = await Api.GetPatientForQrCode(idParams, ssParams, seqAtendParams);

          if (!qrCodeResult.isSuccess || !qrCodeResult.data) {
              qrCodeResult = await Api.GetShared(ssParams);
          }
          
          if (qrCodeResult.isSuccess && qrCodeResult.data) {
             // Buscar imagens separadamente, assim como no InfoPaciente
             const resultImages = await Api.GetImagensPatient(
               qrCodeResult.data.idClient, 
               qrCodeResult.data.idPaciente || idPacienteParams, 
               qrCodeResult.data.seqAtend
             );

             let imagens = [];
             if (resultImages.isSuccess) {
                 imagens = resultImages.data
                  .filter(imagem => {
                    const link = imagem.link || '';
                    if (link.startsWith('https')) {
                      return (
                        (link.includes('/img') ||
                          imagem.nome.endsWith('.dfx') ||
                          imagem.nome.endsWith('.zip')) &&
                        !imagem.nome.includes('tomo_m')
                      );
                    }
                    return !imagem.nome.includes('tomo_m');
                  })
                  .map(imagem => {
                    const link = imagem.link || '';
                    const API_BASE = API_URL || 'https://serapi.cdt.com.br';
                    
                    return {
                      ...imagem,
                      link: link.startsWith('https') ? link : `${API_BASE}${link}`,
                      icone: imagem.icone?.startsWith('https') ? imagem.icone : `${API_BASE}${imagem.icone || ''}`,
                      linkDownload: imagem.linkDownload ? `${API_BASE}${imagem.linkDownload}` : ''
                    };
                  });
             }

             const pacienteViaSS = {
                ...qrCodeResult.data,
                id: qrCodeResult.data.id,
                idPaciente: qrCodeResult.data.idPaciente,
                seqAtend: qrCodeResult.data.seqAtend,
                idClient: qrCodeResult.data.idClient || idParams,
                nome: qrCodeResult.data.paciente || qrCodeResult.data.nome,
                imagem: qrCodeResult.data.imagem ? `${API_URL || ''}${qrCodeResult.data.imagem}` : null,
                imagensPaciente: imagens,
                exames: qrCodeResult.data.exames || []
             };

             console.log("✅ Paciente carregado via SS:", pacienteViaSS);
             dispatch(setResearchPatient(pacienteViaSS));
             setPacientSearchCefx(pacienteViaSS);
          } else {
             console.error("❌ Falha ao buscar paciente via SS");
          }
        } catch (error) {
          console.error("Erro na busca via SS:", error);
        } finally {
          setLoadingPacientSearchCefx(false);
        }
      };

      fetchViaSS();
      // Retornar aqui para evitar conflito com a lógica abaixo se o SS resolver?
      // A lógica abaixo depende de 'user' redux, que pode estar vazio.
      // Vamos permitir a execução abaixo APENAS se não tiver SS ou falhar?
      // Por segurança, se temos SS, confiamos nele.
      return;
    }

    const isCefalometriaUrl = queryParams.get("cefalometria") === "s" || queryParams.get("cefalometria") === "S";

    // Sempre buscar paciente no modo cefalometria no page load ou se URL indicar
    if ((isCefalometria || isCefalometriaUrl) && seqAtendParams) {
      // Se os dados atuais não correspondem aos novos parâmetros, limpar para garantir loading limpo
      if (pacientSearchCefx && (pacientSearchCefx.seqAtend != seqAtendParams || pacientSearchCefx.idClient != idParams)) {
          setPacientSearchCefx(null);
      }
      
      setLoadingPacientSearchCefx(true);
      
      // Validar idParams antes de usar
      if (!idParams) {
          console.error("ID Client ausente nos parâmetros");
          setLoadingPacientSearchCefx(false);
          return;
      }
      
      let filteredUser = Array.isArray(user) ? user.find((u) => u.idClient == idParams) : null;
      
      // Fallback: Se não achar no Redux (ex: refresh), tentar sessionStorage
      if (!filteredUser) {
          try {
              const storedLogins = JSON.parse(sessionStorage.getItem("alogins") || "[]");
              if (Array.isArray(storedLogins)) {
                  filteredUser = storedLogins.find(u => u.idClient == idParams);
                  if (filteredUser) {
                      console.log("Usuário recuperado do sessionStorage:", filteredUser.idClient);
                  }
              }
          } catch (e) {
              console.error("Erro ao ler alogins do sessionStorage", e);
          }
      }

      if (!filteredUser) {
        console.error("Usuário não encontrado para idClient:", idParams);
        setLoadingPacientSearchCefx(false);
        // Redirecionar para login se não encontrar usuário
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        const loginUrl = isCefalometriaUrl 
            ? `/?cli=${idParams}&cefalometria=s&returnUrl=${returnUrl}` 
            : `/?cli=${idParams || ''}&returnUrl=${returnUrl}`;
        navigate(loginUrl);
        return;
      }

      const { hash, idClient } = filteredUser;
      const pacienteNomeParams = queryParams.get("paciente");

      // Função auxiliar para buscar na API Normal (GetPatients)
      const searchInNormalApi = async (searchTerm) => {
        try {
          const result = await Api.GetPatientList({ idClient, hash, page: 0 }, searchTerm);
          if (result.isSuccess && result.data?.patients?.length > 0) {
            // Tentar encontrar por seqAtend primeiro
            let found = result.data.patients.find(
              (p) => p.seqAtend == seqAtendParams && 
                     (idPacienteParams ? p.idPaciente == idPacienteParams : true)
            );
            
            // Se não encontrar exato, e estamos buscando por nome, pegar o primeiro que combine?
            // Por segurança, manter restrito ao seqAtend se possível.
            // Mas se a busca foi por nome textual, talvez o seqAtend não bata se for dados legados?
            // Vamos manter a validação estrita de seqAtend para evitar dados cruzados.
            
            return found || null;
          }
          return null;
        } catch (error) {
          console.error("Erro na busca API Normal:", error);
          return null;
        }
      };


      // Função para formatar URL da imagem
      const formatPatientImage = (patient) => {
        if (!patient) return patient;
        
        const BASE_API_URL = API_URL || 'https://serapi.cdt.com.br';
        let imagemUrl = patient.imagem;
        
        // Tratar URLs da Evolcloud (substituir por avatar padrão se necessário)
        if (imagemUrl && imagemUrl.includes('evolcloud')) {
          imagemUrl = null; // Será tratado pelo componente como avatar padrão
          console.log("URL da Evolcloud encontrada:", imagemUrl);
        }
        
        // Adicionar prefixo para caminhos relativos
        if (imagemUrl && imagemUrl.startsWith('/api/')) {
          console.log("Prefixo adicionado para caminho relativo:", imagemUrl);
          imagemUrl = `${BASE_API_URL}${imagemUrl}`;
        }
        
        return {
          ...patient,
          imagem: imagemUrl,
          imagensPaciente: patient.imagensPaciente || []
        };
      };

      // === FLUXO MULTI-STAGE FALLBACK ===

      const fetchPatientWithFallback = async () => {
        let foundPatient = null;

        // 🟢 Etapa 1: Busca por ID na API Cefx
        console.log("🟢 Etapa 1: Buscando na API Cefx por ID...");
        try {
          const cefxResult = await Api.GetPatientListCefx(
            { idClient, hash, page: 0, seqAtend: seqAtendParams },
            { process_id: -2, to_conclude: -1 },
            { searchName: seqAtendParams }
          );
          
          if (cefxResult.isSuccess) {
            let totalPages = cefxResult.data?.totalPages || 1;
            let currentPagePatients = cefxResult.data?.patients || [];
            
            const checkPatient = (patientsList) => {
              return patientsList.find(
                (p) => p.seqAtend == seqAtendParams &&
                       (idPacienteParams ? p.idPaciente == idPacienteParams : true) &&
                       (p.idClient == idParams || p.idClient == "" || idParams == "")
              );
            };

            foundPatient = checkPatient(currentPagePatients);

            for (let page = 1; page < totalPages && !foundPatient; page++) {
              console.log(`🔎 Buscando na página ${page} de ${totalPages}...`);
              const pageResult = await Api.GetPatientListCefx(
                { idClient, hash, page },
                { process_id: -2, to_conclude: -1 }
              );
              if (pageResult.isSuccess && pageResult.data?.patients) {
                foundPatient = checkPatient(pageResult.data.patients);
              }
            }
            
            if (foundPatient) {
              console.log("✅ Paciente encontrado na API Cefx");
            }
          }
        } catch (error) {
          console.error("Erro na Etapa 1 (Cefx):", error);
        }

        // 🟡 Etapa 2: Cross-Search na API Normal (se Etapa 1 falhou)
        // Restaurado pois o usuário confirmou que GetPatients retorna os dados corretos em alguns casos
        if (!foundPatient) {
          console.log("🟡 Etapa 2: Cross-Search na API Normal...");
          
          // Tentar por SeqAtend
          foundPatient = await searchInNormalApi(seqAtendParams);
          
          // Tentar por ID Paciente
          if (!foundPatient && idPacienteParams) {
            console.log("🟡 Tentando por ID Paciente na API Normal...");
            foundPatient = await searchInNormalApi(idPacienteParams);
          }

          // Tentar por NOME na API Normal (Fallback do Fallback)
          if (!foundPatient && pacienteNomeParams) {
             console.log("🟡 Tentando por NOME na API Normal...");
             const decodedName = decodeURIComponent(pacienteNomeParams).replace(/_/g, ' ');
             foundPatient = await searchInNormalApi(decodedName);
          }
          
          if (foundPatient) {
            console.log("✅ Paciente encontrado na API Normal");
          }
        }

        // 🔴 Etapa 3: Busca por Nome na Cefx (último recurso preferencial para Cefx)
        if (!foundPatient && pacienteNomeParams) {
          console.log("🔴 Etapa 3: Buscando por nome na Cefx...");
          try {
            const decodedName = decodeURIComponent(pacienteNomeParams).replace(/_/g, ' ');
            const cefxByNameResult = await Api.GetPatientListCefx(
              { idClient, hash, page: 0 },
              { process_id: -2, to_conclude: -1 },
              { searchName: decodedName }
            );
            
            if (cefxByNameResult.isSuccess && cefxByNameResult.data?.patients?.length > 0) {   
              // Validação estrita: O paciente retornado por nome DEVE corresponder ao seqAtend da URL
              // Isso previne pegar um homônimo ou um atendimento antigo do mesmo paciente
              foundPatient = cefxByNameResult.data.patients.find(
                (p) => p.seqAtend == seqAtendParams
              );
              
              if (!foundPatient) {
                  // Fallback apenas se bater ID E Nome, para evitar erros grosseiros
                  if (idPacienteParams) {
                      foundPatient = cefxByNameResult.data.patients.find(
                        (p) => p.idPaciente == idPacienteParams
                      );
                  }
              }
              
              if (foundPatient) {
                console.log("✅ Paciente encontrado por nome na Cefx");
              }
            }
          } catch (error) {
            console.error("Erro na Etapa 3 (Nome Cefx):", error);
          }
        }

        if (!foundPatient) {
          console.error("❌ Paciente não encontrado em nenhuma etapa");
          return null;
        }

        // === EXTRAÇÃO E NORMALIZAÇÃO DE DADOS ===
        // A API retorna dentro de foundPatient (que veio de data.patients[i])
        // Mapeamos explicitamente os campos que o Front precisa para evitar erros
        const normalizedPatient = {
          // Identificadores
          id: foundPatient.id,
          idPaciente: foundPatient.idPaciente,
          seqAtend: foundPatient.seqAtend,
          idClient: foundPatient.idClient || idParams, // Garantir idClient

          // Dados Pessoais
          nome: foundPatient.paciente || foundPatient.nome, // API Cefx usa 'paciente'
          idade: foundPatient.idade, // Ex: "29a 0m"
          dataNasc: foundPatient.dataNasc,
          sexo: foundPatient.sexo,
          
          // Imagens e Dados Complementares
          imagem: foundPatient.imagem, // Url bruta da API
          imagensPaciente: foundPatient.imagensPaciente || [],
          exames: foundPatient.exames || [],
          
          // Outros (mantendo compatibilidade com resto do objeto se necessário)
          ...foundPatient 
        };
        
        // === FORMATAÇÃO FINAL DA IMAGEM ===
        // Trata caminhos relativos e Evolcloud
        const finalPatient = formatPatientImage(normalizedPatient);
        
        console.log("✅ Paciente Processado:", { 
          id: finalPatient.idPaciente,
          seq: finalPatient.seqAtend,
          nome: finalPatient.nome,
          idade: finalPatient.idade,
          img: finalPatient.imagem ? "Sim" : "Não"
        });
        
        return finalPatient;
      };

      // Executar o fluxo
      fetchPatientWithFallback().then((result) => {
        if (result) {
          // Salvar no Redux store com dados completos
          dispatch(setResearchPatient(result));
        }
        setPacientSearchCefx(result);
        setLoadingPacientSearchCefx(false);
      });
    }
  }, [isCefalometria, user, idParams, seqAtendParams, idPacienteParams, dispatch, ssParams]);

  // Sincronizar resultSearch quando researchPatient do Redux mudar
  useEffect(() => {
    if (researchPatient && 
        researchPatient.seqAtend == seqAtendParams &&
        researchPatient.idPaciente == idPacienteParams) {
      setResultSearch(researchPatient);
    }
  }, [researchPatient, seqAtendParams, idPacienteParams]);

  /*---------- 3d ---------*/
  const myViewer = useRef(new CViewer3d());
  const oViewer = myViewer.current;
  const [viwerActives, setViwerActives] = useState([]);

  const handleViwerActivesChange = (newViwerActives) => {
    setViwerActives(newViwerActives);
  };

  /*---------- Cefx ---------*/
  const myCefx = useRef(new CefxLib());
  const ocefx = myCefx.current;
  const [selectedImages, setSelectedImages] = useState();

  const selectedImageChange = (newCheckedImage) => {
    setSelectedImages(newCheckedImage);
  };

  return (
    <div className={styles.wrapper}>
      {!modoCefXViewImage && imageParams ? (
        <OpcoesProvider ocefx={ocefx}>
          <main className={styles.main}>
            <ViewImageComponent
              infoPaciente={paciente}
              tamanhoParams={tamanhoParams}
              getCollapse={getCollapse}
              theSelectImage={theSelectImage}
              handleSelectedImage={handleSelectedImage}
              handleModoCefX={handleModoCefXViewImage}
              pacienteAllImagensArray={pacienteAllImagensArray}
              pacientAllImagens3d={pacientAllImagens3d}
              imageParams={imageParams}
              selectedImage={selectedImage}
              valueImageRotate={imageRotation}
              viwerActives={viwerActives}
              oViewer={oViewer}
              ocefx={ocefx}
              selectedImages={selectedImages}
              handleChanceTheSelectedImage={handleChanceTheSelectedImage}
            />
          </main>

          <NewSidebarView
            imageParams={imageParams}
            infoPaciente={paciente}
            handleSelectedImage={handleSelectedImage}
            pacienteAllImagensArray={pacienteAllImagensArray}
            pacientAllImagens3d={pacientAllImagens3d}
            getImagenRotation={getImagenRotation}
            image3d={image3d}
            handleChanceTheSelectedImage={handleChanceTheSelectedImage}
            oViewer={oViewer}
            viwerActives={viwerActives}
            valueImageRotate={imageRotation}
            onViwerActivesChange={handleViwerActivesChange}
            selectedImageChange={selectedImageChange}
            ocefx={ocefx}
            handleGetCollapse={handleGetCollapse}
            theSelectImage={theSelectImage}
          />
        </OpcoesProvider>
      ) : (
        <OpcoesProvider ocefx={ocefx}>
          <main className={styles.main}>
            <CefxComponent
              infoPaciente={paciente || pacientSearchCefx || researchPatient }
              handleModoCefX={() => {}}
              handleModoCefXViewImage={handleModoCefXViewImage}
              imageParams={imageParams}
              ocefx={ocefx}
              analysisSelected={analysisSelected}
              getTextPont={getTextPont}
              textPont={textPont}
              pointNameOnTableClick={pointNameOnTableClick}
              handleGetNameEndCodAnalyze={handleGetNameEndCodAnalyze}
            />
          </main>

          <NewSidebarCefx
            loadingPacientSearchCefx={loadingPacientSearchCefx}
            infoPaciente={paciente || pacientSearchCefx || researchPatient }
            textPont={textPont}
            ocefx={ocefx}
            handleGetNameEndCodAnalyze={handleGetNameEndCodAnalyze}
            handlePontName={handlePontName}
          />
        </OpcoesProvider>
      )}

      <>
        {(isModalIaOpen || isModalLoadingOpen) && (
          <div className="react_modal_overlayIa" />
        )}

        {isModalIaOpen && (
          <ModalIa
            isOpen={isModalIaOpen}
            onRequestClose={closeModalIa}
            onLoadIa={handleLoadIa}
          />
        )}

        {isModalLoadingOpen && (
          <ModalLoadingProcessIa
            isOpen={isModalLoadingOpen}
            onRequestClose={closeModalLoading}
          />
        )}
      </>
    </div>
  );
}
